export const config = {
  apikey: process.env.REACT_APP_API_KEY,
  appURL: process.env.REACT_APP_APP_URL,
  apiURL: process.env.REACT_APP_API_URL,
  cookieDomain: process.env.REACT_APP_COOKIE_DOMAIN || 'localhost'
}

export const publicUrl = (file: string) => `${process.env.PUBLIC_URL}/${file}`